/**
 * WooCommerce Stuff!
 *
 * @package naschwerk
 * @since 1.0.0
 * @author hype.media <web@hype-media.de>
 */
import Cookies from 'js-cookie';


export function wooStuff() {
    $( '.woocommerce-ordering' ).on( 'change', 'select.orderby', function() {
        $( this ).closest( 'form' ).submit();
    });

    // Target quantity inputs on product pages
    $( 'input.qty:not(.product-quantity input.qty)' ).each( function() {
        var min = parseFloat( $( this ).attr( 'min' ) );

        if ( min >= 0 && parseFloat( $( this ).val() ) < min ) {
            $( this ).val( min );
        }
    });

    var noticeID   = $( '.woocommerce-store-notice' ).data( 'notice-id' ) || '',
        cookieName = 'store_notice' + noticeID;

    // Check the value of that cookie and show/hide the notice accordingly
    if ( 'hidden' === Cookies.get( cookieName ) ) {
        $( '.woocommerce-store-notice' ).hide();
    } else {
        $( '.woocommerce-store-notice' ).show();
    }

    // Set a cookie and hide the store notice when the dismiss button is clicked
    $( '.woocommerce-store-notice__dismiss-link' ).click( function( event ) {
        Cookies.set( cookieName, 'hidden', { path: '/' } );
        $( '.woocommerce-store-notice' ).hide();
        event.preventDefault();
    });

    // Make form field descriptions toggle on focus.
    if ( $( '.woocommerce-input-wrapper span.description' ).length ) {
        $( document.body ).on( 'click', function() {
            $( '.woocommerce-input-wrapper span.description:visible' ).prop( 'aria-hidden', true ).slideUp( 250 );
        } );
    }

    $( '.woocommerce-input-wrapper' ).on( 'click', function( event ) {
        event.stopPropagation();
    } );

    $( '.woocommerce-input-wrapper :input' )
        .on( 'keydown', function( event ) {
            var input       = $( this ),
                parent      = input.parent(),
                description = parent.find( 'span.description' );

            if ( 27 === event.which && description.length && description.is( ':visible' ) ) {
                description.prop( 'aria-hidden', true ).slideUp( 250 );
                event.preventDefault();
                return false;
            }
        } )
        .on( 'click focus', function() {
            var input       = $( this ),
                parent      = input.parent(),
                description = parent.find( 'span.description' );

            parent.addClass( 'currentTarget' );

            $( '.woocommerce-input-wrapper:not(.currentTarget) span.description:visible' ).prop( 'aria-hidden', true ).slideUp( 250 );

            if ( description.length && description.is( ':hidden' ) ) {
                description.prop( 'aria-hidden', false ).slideDown( 250 );
            }

            parent.removeClass( 'currentTarget' );
        } );

    // Common scroll to element code.
    $.scroll_to_notices = function( scrollElement ) {
        if ( scrollElement.length ) {
            $( 'html, body' ).animate( {
                scrollTop: ( scrollElement.offset().top - 100 )
            }, 1000 );
        }
    };

    // Show password visiblity hover icon on woocommerce forms
    $( '.woocommerce form .woocommerce-Input[type="password"]' ).wrap( '<span class="password-input"></span>' );
    // Add 'password-input' class to the password wrapper in checkout page.
    $( '.woocommerce form input' ).filter(':password').parent('span').addClass('password-input');
    $( '.password-input' ).append( '<span class="show-password-input"></span>' );

    $( '.show-password-input' ).click(
        function() {
            $( this ).toggleClass( 'display-password' );
            if ( $( this ).hasClass( 'display-password' ) ) {
                $( this ).siblings( ['input[type="password"]'] ).prop( 'type', 'text' );
            } else {
                $( this ).siblings( 'input[type="text"]' ).prop( 'type', 'password' );
            }
        }
    );
}

export function singleProducts() {
    jQuery( function( $ ) {
        // wc_single_product_params is required to continue.
        if (typeof wc_single_product_params === 'undefined') {
            return false;
        }

        $('body')
            // Tabs
            .on('init', '.wc-tabs-wrapper, .woocommerce-tabs', function () {
                $(this).find('.wc-tab, .woocommerce-tabs .panel:not(.panel .panel)').hide();

                var hash = window.location.hash;
                var url = window.location.href;
                var $tabs = $(this).find('.wc-tabs, ul.tabs').first();

                if (hash.toLowerCase().indexOf('comment-') >= 0 || hash === '#reviews' || hash === '#tab-reviews') {
                    $tabs.find('li.reviews_tab a').click();
                } else if (url.indexOf('comment-page-') > 0 || url.indexOf('cpage=') > 0) {
                    $tabs.find('li.reviews_tab a').click();
                } else if (hash === '#tab-additional_information') {
                    $tabs.find('li.additional_information_tab a').click();
                } else {
                    $tabs.find('li:first a').click();
                }
            })
            .on('click', '.wc-tabs li a, ul.tabs li a', function (e) {
                e.preventDefault();
                var $tab = $(this);
                var $tabs_wrapper = $tab.closest('.wc-tabs-wrapper, .woocommerce-tabs');
                var $tabs = $tabs_wrapper.find('.wc-tabs, ul.tabs');

                $tabs.find('li').removeClass('active');
                $tabs_wrapper.find('.wc-tab, .panel:not(.panel .panel)').hide();

                $tab.closest('li').addClass('active');
                $tabs_wrapper.find($tab.attr('href')).show();
            })
            // Review link
            .on('click', 'a.woocommerce-review-link', function () {
                $('.reviews_tab a').click();
                return true;
            })
            // Star ratings for comments
            .on('init', '#rating', function () {
                $('#rating')
                    .hide()
                    .before(
                        '<p class="stars">\
                            <span>\
                                <a class="star-1" href="#">1</a>\
                                <a class="star-2" href="#">2</a>\
                                <a class="star-3" href="#">3</a>\
                                <a class="star-4" href="#">4</a>\
                                <a class="star-5" href="#">5</a>\
                            </span>\
                        </p>'
                    );
            })
            .on('click', '#respond p.stars a', function () {
                var $star = $(this),
                    $rating = $(this).closest('#respond').find('#rating'),
                    $container = $(this).closest('.stars');

                $rating.val($star.text());
                $star.siblings('a').removeClass('active');
                $star.addClass('active');
                $container.addClass('selected');

                return false;
            })
            .on('click', '#respond #submit', function () {
                var $rating = $(this).closest('#respond').find('#rating'),
                    rating = $rating.val();

                if ($rating.length > 0 && !rating && wc_single_product_params.review_rating_required === 'yes') {
                    window.alert(wc_single_product_params.i18n_required_rating_text);

                    return false;
                }
            });

        // Init Tabs and Star Ratings
        $('.wc-tabs-wrapper, .woocommerce-tabs, #rating').trigger('init');

        /**
         * Product gallery class.
         */
        var ProductGallery = function ($target, args) {
            this.$target = $target;
            this.$images = $('.woocommerce-product-gallery__image', $target);

            // No images? Abort.
            if (0 === this.$images.length) {
                this.$target.css('opacity', 1);
                return;
            }

            // Make this object available.
            $target.data('product_gallery', this);

            // Pick functionality to initialize...
            this.flexslider_enabled = $.isFunction($.fn.flexslider) && wc_single_product_params.flexslider_enabled;
            this.zoom_enabled = $.isFunction($.fn.zoom) && wc_single_product_params.zoom_enabled;
            this.photoswipe_enabled = typeof PhotoSwipe !== 'undefined' && wc_single_product_params.photoswipe_enabled;

            // ...also taking args into account.
            if (args) {
                this.flexslider_enabled = false === args.flexslider_enabled ? false : this.flexslider_enabled;
                this.zoom_enabled = false === args.zoom_enabled ? false : this.zoom_enabled;
                this.photoswipe_enabled = false === args.photoswipe_enabled ? false : this.photoswipe_enabled;
            }

            // ...and what is in the gallery.
            if (1 === this.$images.length) {
                this.flexslider_enabled = false;
            }

            // Bind functions to this.
            this.initFlexslider = this.initFlexslider.bind(this);
            this.initZoom = this.initZoom.bind(this);
            this.initZoomForTarget = this.initZoomForTarget.bind(this);
            this.initPhotoswipe = this.initPhotoswipe.bind(this);
            this.onResetSlidePosition = this.onResetSlidePosition.bind(this);
            this.getGalleryItems = this.getGalleryItems.bind(this);
            this.openPhotoswipe = this.openPhotoswipe.bind(this);

            if (this.flexslider_enabled) {
                this.initFlexslider(args.flexslider);
                $target.on('woocommerce_gallery_reset_slide_position', this.onResetSlidePosition);
            } else {
                this.$target.css('opacity', 1);
            }

            if (this.zoom_enabled) {
                this.initZoom();
                $target.on('woocommerce_gallery_init_zoom', this.initZoom);
            }

            if (this.photoswipe_enabled) {
                this.initPhotoswipe();
            }
        };

        /**
         * Initialize flexSlider.
         */
        ProductGallery.prototype.initFlexslider = function (args) {
            var $target = this.$target,
                gallery = this;

            var options = $.extend({
                selector: '.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image',
                start: function () {
                    $target.css('opacity', 1);
                },
                after: function (slider) {
                    gallery.initZoomForTarget(gallery.$images.eq(slider.currentSlide));
                }
            }, args);

            $target.flexslider(options);

            // Trigger resize after main image loads to ensure correct gallery size.
            $('.woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image:eq(0) .wp-post-image').one('load', function () {
                var $image = $(this);

                if ($image) {
                    setTimeout(function () {
                        var setHeight = $image.closest('.woocommerce-product-gallery__image').height();
                        var $viewport = $image.closest('.flex-viewport');

                        if (setHeight && $viewport) {
                            $viewport.height(setHeight);
                        }
                    }, 100);
                }
            }).each(function () {
                if (this.complete) {
                    $(this).trigger('load');
                }
            });
        };

        /**
         * Init zoom.
         */
        ProductGallery.prototype.initZoom = function () {
            this.initZoomForTarget(this.$images.first());
        };

        /**
         * Init zoom.
         */
        ProductGallery.prototype.initZoomForTarget = function (zoomTarget) {
            if (!this.zoom_enabled) {
                return false;
            }

            var galleryWidth = this.$target.width(),
                zoomEnabled = false;

            $(zoomTarget).each(function (index, target) {
                var image = $(target).find('img');

                if (image.data('large_image_width') > galleryWidth) {
                    zoomEnabled = true;
                    return false;
                }
            });

            // But only zoom if the img is larger than its container.
            if (zoomEnabled) {
                var zoom_options = $.extend({
                    touch: false
                }, wc_single_product_params.zoom_options);

                if ('ontouchstart' in document.documentElement) {
                    zoom_options.on = 'click';
                }

                zoomTarget.trigger('zoom.destroy');
                zoomTarget.zoom(zoom_options);

                setTimeout(function () {
                    if (zoomTarget.find(':hover').length) {
                        zoomTarget.trigger('mouseover');
                    }
                }, 100);
            }
        };

        /**
         * Init PhotoSwipe.
         */
        ProductGallery.prototype.initPhotoswipe = function () {
            if (this.zoom_enabled && this.$images.length > 0) {
                this.$target.prepend('<a href="#" class="woocommerce-product-gallery__trigger">🔍</a>');
                this.$target.on('click', '.woocommerce-product-gallery__trigger', this.openPhotoswipe);
                this.$target.on('click', '.woocommerce-product-gallery__image a', function (e) {
                    e.preventDefault();
                });

                // If flexslider is disabled, gallery images also need to trigger photoswipe on click.
                if (!this.flexslider_enabled) {
                    this.$target.on('click', '.woocommerce-product-gallery__image a', this.openPhotoswipe);
                }
            } else {
                this.$target.on('click', '.woocommerce-product-gallery__image a', this.openPhotoswipe);
            }
        };

        /**
         * Reset slide position to 0.
         */
        ProductGallery.prototype.onResetSlidePosition = function () {
            this.$target.flexslider(0);
        };

        /**
         * Get product gallery image items.
         */
        ProductGallery.prototype.getGalleryItems = function () {
            var $slides = this.$images,
                items = [];

            if ($slides.length > 0) {
                $slides.each(function (i, el) {
                    var img = $(el).find('img');

                    if (img.length) {
                        var large_image_src = img.attr('data-large_image'),
                            large_image_w = img.attr('data-large_image_width'),
                            large_image_h = img.attr('data-large_image_height'),
                            alt = img.attr('alt'),
                            item = {
                                alt: alt,
                                src: large_image_src,
                                w: large_image_w,
                                h: large_image_h,
                                title: img.attr('data-caption') ? img.attr('data-caption') : img.attr('title')
                            };
                        items.push(item);
                    }
                });
            }

            return items;
        };

        /**
         * Open photoswipe modal.
         */
        ProductGallery.prototype.openPhotoswipe = function (e) {
            e.preventDefault();

            var pswpElement = $('.pswp')[0],
                items = this.getGalleryItems(),
                eventTarget = $(e.target),
                clicked;

            if (eventTarget.is('.woocommerce-product-gallery__trigger') || eventTarget.is('.woocommerce-product-gallery__trigger img')) {
                clicked = this.$target.find('.flex-active-slide');
            } else {
                clicked = eventTarget.closest('.woocommerce-product-gallery__image');
            }

            var options = $.extend({
                index: $(clicked).index(),
                addCaptionHTMLFn: function (item, captionEl) {
                    if (!item.title) {
                        captionEl.children[0].textContent = '';
                        return false;
                    }
                    captionEl.children[0].textContent = item.title;
                    return true;
                }
            }, wc_single_product_params.photoswipe_options);

            // Initializes and opens PhotoSwipe.
            var photoswipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            photoswipe.init();
        };

        /**
         * Function to call wc_product_gallery on jquery selector.
         */
        $.fn.wc_product_gallery = function (args) {
            new ProductGallery(this, args || wc_single_product_params);
            return this;
        };

        /*
         * Initialize all galleries on page.
         */
        $('.woocommerce-product-gallery').each(function () {

            $(this).trigger('wc-product-gallery-before-init', [this, wc_single_product_params]);

            $(this).wc_product_gallery(wc_single_product_params);

            $(this).trigger('wc-product-gallery-after-init', [this, wc_single_product_params]);

        });

        $('#url-sharing').on('click', function(e) {
            e.preventDefault();

            let copyText = document.getElementById("url-to-share");

            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
        });
    });
}

export function wishList() {
    Array.prototype.unique = function() {
        return this.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    }

    function isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    function onWishlistComplete(target, title){
        setTimeout(function() {
            target.removeClass('loading').addClass('active').attr('title', title);
            target.find('.heart-icon').removeClass('backpress-heart-empty').addClass('backpress-heart');
        }, 800);
    }

    function highlightWishlist(wishlist,title){
        $('.wishlist-toggle').each(function(){
            var $this = $(this);
            var currentProduct = $this.data('product');
            currentProduct = currentProduct.toString();
            if (isInArray(currentProduct, wishlist)) {
                $this.addClass('active').attr('title', title);
                $this.find('.heart-icon').removeClass('backpress-heart-empty').addClass('backpress-heart');
            }
        });
    }

    var shopName   = opt.shopName + '-wishlist',
        inWishlist = opt.inWishlist,
        restUrl    = opt.restUrl,
        wishlist   = new Array,
        ls         = sessionStorage.getItem(shopName),
        loggedIn   = !!($('body').hasClass('logged-in')),
        userData   = '';

    if(loggedIn) {
        // Fetch current user data
        $.ajax({
            type: 'POST',
            url: opt.ajaxUrl,
            data: {
                'action' : 'fetch_user_data',
                'dataType': 'json'
            },
            success: function(data) {
                userData = JSON.parse(data);

                if (typeof(userData['wishlist']) != 'undefined' && userData['wishlist'] != null && userData['wishlist'] !== "") {
                    var userWishlist = userData['wishlist'];
                    userWishlist = userWishlist.split(',');

                    if (wishlist.length) {
                        wishlist =  wishlist.concat(userWishlist);

                        $.ajax({
                            type: 'POST',
                            url: opt.ajaxPost,
                            data:{
                                action:     'user_wishlist_update',
                                user_id:    userData['user_id'],
                                wishlist:   wishlist.join(','),
                            }
                        });

                    } else {
                        wishlist =  userWishlist;
                    }

                    wishlist = wishlist.unique();

                    highlightWishlist( wishlist, inWishlist );
                    sessionStorage.removeItem(shopName);
                } else {
                    if (typeof(ls) != 'undefined' && ls != null) {
                        ls = ls.split(',');
                        ls = ls.unique();
                        wishlist = ls;
                    }

                    $.ajax({
                        type: 'POST',
                        url: opt.ajaxPost,
                        data: {
                            action:'user_wishlist_update',
                            user_id :userData['user_id'],
                            wishlist :wishlist.join(','),
                        }
                    }).done(function(response) {
                        highlightWishlist(wishlist,inWishlist);
                        sessionStorage.removeItem(shopName);
                    });
                }
            },
            error: function(){
                console.log(':(');
            }
        });
    } else {
        if (typeof(ls) != 'undefined' && ls != null) {
            ls = ls.split(',');
            ls = ls.unique();
            wishlist = ls;
        }
    }

    $('.wishlist-toggle').each(function(){
        var $this = $(this);

        var currentProduct = $this.data('product');

        currentProduct = currentProduct.toString();

        if (!loggedIn && isInArray(currentProduct, wishlist)) {
            $this.addClass('active').attr('title', inWishlist);
        }

        $(this).on('click',function(e){
            e.preventDefault();
            if (!$this.hasClass('active') && !$this.hasClass('loading')) {

                $this.addClass('loading');

                wishlist.push(currentProduct);
                wishlist = wishlist.unique();

                if (loggedIn) {
                    // get user ID
                    if (userData['user_id']) {
                        $.ajax({
                            type: 'POST',
                            url: opt.ajaxPost,
                            data:{
                                action:     'user_wishlist_update',
                                user_id:    userData['user_id'],
                                wishlist:   wishlist.join(','),
                            }
                        }).done(function(response) {
                            onWishlistComplete($this, inWishlist);
                        }).fail(function(data) {
                            alert(opt.error);
                        });
                    }
                } else {
                    sessionStorage.setItem(shopName, wishlist.toString());
                    onWishlistComplete($this, inWishlist);
                }
            } else if ($this.hasClass('active')) {

            }
        });
    });

    setTimeout(function() {
        if (wishlist.length) {
            restUrl += '?include=' + wishlist.join(',');
            restUrl += '&per_page=' + wishlist.length;

            $.ajax({
                dataType: 'json',
                url: restUrl
            }).done(function(response){
                $('.wishlist-table').each(function(){
                    var $this = $(this);
                    $.each(response, function(index, object) {
                        $this.append('<tr data-product="' + object.id + '"><td><a class="wishlist-remove" href="#" title="' + opt.removeWishlist + '"></a>' + object.image + '</td><td>' + object.title["rendered"] + '</td><td>' + object.price + '</td><td>' + object.stock + '</td><td><a class="details" href="' + object.link + '">' + opt.buttonText + '</a></td></tr>');
                    });
                });
            }).fail(function(response){
                alert(opt.noWishlist);
            }).always(function(response){
                $('.wishlist-table').each(function(){
                    $(this).removeClass('loading');
                });
            });
        } else {
            $('.wishlist-table').each(function(){
                $(this).removeClass('loading');
            });
        }
    }, 1);

    $(document).on('click', '.wishlist-remove', function(){
        var $this = $(this);
        $this.closest('table').addClass('loading');
        wishlist = [];
        $this.closest('table').find('tr').each(function(){
            if ($(this).data('product') !== $this.closest('tr').data('product')) {
                wishlist.push($(this).data('product'));

                if (loggedIn) {
                    // get user ID
                    if (userData['user_id']) {
                        $.ajax({
                            type: 'POST',
                            url: opt.ajaxPost,
                            data: {
                                action:     'user_wishlist_update',
                                user_id:    userData['user_id'],
                                wishlist:   wishlist.join(','),
                            }
                        }).done(function(response) {
                            $this.closest('table').removeClass('loading');
                            $this.closest('tr').remove();
                        }).fail(function(data) {
                            alert(opt.error);
                        });
                    }
                } else {
                    sessionStorage.setItem(shopName, wishlist.toString());
                    setTimeout(function() {
                        $this.closest('table').removeClass('loading');
                        $this.closest('tr').remove();
                    }, 500);
                }
            }
        });
    });
}
